import { RequestProductsSearch } from "../../model";

export type PlpDataSourceProductList_ProductListQueryKeyType = [
  string,
  Omit<RequestProductsSearch, "offset" | "channel">
];

export const PlpDataSourceProductList_QueryKey = {
  productList: (
    desiredProductList: RequestProductsSearch
  ): PlpDataSourceProductList_ProductListQueryKeyType => {
    const baseQueryKey = "plp-data-source-product-list";

    const { offset, channel, ...desiredProductList_withoutOffset } = {
      ...desiredProductList,
    };

    const queryKeyDynamics: PlpDataSourceProductList_ProductListQueryKeyType[1] =
      desiredProductList_withoutOffset;

    const queryKey: PlpDataSourceProductList_ProductListQueryKeyType = [
      baseQueryKey,
      queryKeyDynamics,
    ];

    return queryKey;
  },
};
